<agr-form-dialog
  [formGroup]="formGroup"
  (confirm)="save()"
  (alt)="alt()"
  (cancel)="cancel()"
  [data]="data"
>
  <div style="border-top: 1px solid rgba(0, 0, 0, 0.12)">
    <h4>{{ 'observation-settings.description' | translate }}</h4>

    <div class="spacing--margin-top">
      <div *ngFor="let control of controlNames">
        <mat-label class="text--bold text--small">
          {{ 'observations-labels.' + control | translate }}
        </mat-label>
        <div>
          <mat-slide-toggle
            [hideIcon]="true"
            [formControlName]="control"
            [attr.data-test]="'setting_' + control"
            color="primary"
            labelPosition="before"
          >
          </mat-slide-toggle>
        </div>
      </div>
    </div>
  </div>
</agr-form-dialog>
